import React from 'react';
import { User } from 'lucide-react';

interface ProfilePhotoProps {
  photoUrl?: string;
  name?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const ProfilePhoto: React.FC<ProfilePhotoProps> = ({
  photoUrl,
  name,
  size = 'md',
  className = ''
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'xs':
        return 'w-6 h-6 text-[10px]';
      case 'sm':
        return 'w-8 h-8 text-xs';
      case 'lg':
        return 'w-16 h-16 text-lg';
      case 'xl':
        return 'w-20 h-20 text-xl';
      default:
        return 'w-12 h-12 text-sm';
    }
  };

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className={`relative ${getSizeClasses()} ${className}`}>
      {photoUrl ? (
        <img
          src={photoUrl}
          alt={name ? `Foto de ${name}` : 'Foto de perfil'}
          className="w-full h-full rounded-full object-cover border-2 border-gray-200 dark:border-gray-700"
        />
      ) : (
        <div className="w-full h-full rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center border-2 border-gray-300 dark:border-gray-600">
          {name ? (
            <span className="font-medium text-gray-700 dark:text-gray-300">
              {getInitials(name)}
            </span>
          ) : (
            <User className="w-1/2 h-1/2 text-gray-400" />
          )}
        </div>
      )}
    </div>
  );
}; 